import React, { useEffect, useRef } from 'react';
import { useT } from 'talkr';
import steps from '../../survey/steps';
import { useAppStore } from '../../store';
import s from './index.module.scss';

const FULL_WIDTH_BOTTOM_BAR_STEPS = new Set([
  'customV1_startPage',
  'customV2_startPage',
  'customV2_policyPage',
  'customV2_policyPageV2',
  'customV2_policyPageV3',
  'customV2_policyPageV4',
  'customV2_policyPageV5',
  'customV2_policyPageV6',
  'customV2_videoPolicyPage',
  'customV2_startPageV2',
  'customV2_startPageV3',
  'customV2_startPageV4',
  'customV2_startPageV47',
  'customV2_startPageV5',
  'customV2_startPageV6',
  'customV2_startPageV7',
  'customV2_startPageV8',
  'customV2_startPageV11',
  'customV2_startPageV12',
  'customV2_startPageV13',
  'customV2_startPageV17',
  'customV2_startPageV18',
  'customV2_startPageV19',
  'customV2_startPageV20',
  'customV2_startPageV21',
  'customV2_startPageV22',
  'customV2_startPageV23',
  'customV2_startPageV24',
  'customV2_startPageV25',
  'customV2_startPageV26',
  'customV2_startPageV27',
  'customV2_startPageV28',
  'customV2_startPageV29',
  'customV2_startPageV30',
  'customV2_startPageV31',
  'customV2_startPageV34',
  'customV2_startPageV37',
  'customV2_startPageV44',
]);

const POLICY_PAGE_STEPS = new Set([
  'customV2_policyPage',
  'customV2_policyPageV2',
  'customV2_policyPageV3',
  'customV2_policyPageV4',
  'customV2_policyPageV5',
  'customV2_policyPageV6',
  'customV2_videoPolicyPage',
]);

type ActionBarPrimaryProps = {
  show?: boolean | null;
  currentStepCompleted?: boolean | null;
  transparentBg?: boolean;
  whiteStyle?: boolean;
  withShadow?: boolean;
  v2?: boolean;
  continueText?: string;
};

function ActionBarPrimary({
  show,
  currentStepCompleted,
  transparentBg,
  whiteStyle,
  withShadow,
  v2,
  continueText,
}: ActionBarPrimaryProps) {
  const { T } = useT();
  const currentStep = useAppStore((state) => state.currentStep);
  const currentStepIndex = useAppStore((state) => state.currentStepIndex);

  const stateClass = show ? s.show : '';
  const transparentBgClass = transparentBg ? s.transparentBg : '';
  const isFirstStep = currentStepIndex === 0 && !continueText;
  const isStepRole = currentStep === 'role';
  const whiteStyleClass = whiteStyle ? s.whiteStyle : '';
  const withShadowClass = withShadow ? s.withShadow : '';
  const withV2Class = v2 ? s.v2 : '';
  const bottomBar = FULL_WIDTH_BOTTOM_BAR_STEPS.has(currentStep ?? '')
    ? s.fullWidth
    : s.bottomBar;

  const actionBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (POLICY_PAGE_STEPS.has(currentStep ?? '') && actionBarRef.current) {
      actionBarRef.current.style.top = 'auto';
    }
  }, [currentStep]);

  function forward(): void {
    if (!currentStepCompleted) return;

    if (!isStepRole) {
      steps.navigate.forward({ preventAction: 500 });
    }

    steps.userMovedToNextStepByClick({ byNextStep: false });
  }

  const buttonText = continueText
    ?? T(isFirstStep ? 'get_started' : 'continue');

  return (
    <div
      className={`${s.actionBar} ${stateClass} ${transparentBgClass} ${whiteStyleClass} ${withShadowClass} ${bottomBar} ${withV2Class}`}
      ref={actionBarRef}
    >
      <button
        className={s.completeButton}
        type="button"
        onClick={forward}
        onTouchStart={forward}
        disabled={!currentStepCompleted}
      >
        {buttonText}
      </button>
    </div>
  );
}

ActionBarPrimary.defaultProps = {
  show: undefined,
  currentStepCompleted: undefined,
  transparentBg: undefined,
  whiteStyle: undefined,
  withShadow: undefined,
  v2: undefined,
  continueText: undefined,
};

export default ActionBarPrimary;
